<template>
  <div :class="modalTheme">
    <!-- <h3>PRIMARY TEST</h3> -->
    <div :class="userStore.borderClass">
      <!-- <h3>PRIMARY TEST</h3> -->
      <!-- <h6>modalTheme: {{ modalTheme }}</h6> -->
      <!-- greetOne  {{ greetOne() }} -->
      <!-- greetTwo  {{ greetTwo() }} -->
      <!-- <b-button @click="greetOne()">greet ONE</b-button> -->

      <h6 v-if="AreIdsShown" style="background: darkred; color: cyan">PIE: selectedWidgetFilter {{ workListStore.selectedWidgetFilter }}</h6>
      <!-- <h4 v-if="AreIdsShown" style="background: darkgoldenrod; color: yellow">this.widgetArray{{ workListStore.widgetArray }}</h4> -->

      <!-- <h5  v-if="AreIdsShown" style="background:darkgreen;color:yellow;"> INC records{{ records.length }} arrayId  {{ arrayId }}  selectedFileName {{ selectedFileName }}</h5> -->
      <h4 v-if="AreIdsShown" style="background: darkgoldenrod; color: yellow">filterDummyGrid(this.widgetArray) {{ filterDummyGrid().length }}</h4>
      <!-- <h4 v-if="AreIdsShown" style="background: darkblue; color: yellow">filterDummyGrid2(records) {{ filterDummyGrid2().length }}</h4> -->

      <!-- & ReDo CARD VIEW
    &  CSS BROKE CARDVIEW cards -->
      <!-- {{ filterDummyGrid2() }} -->

      <b-row style="margin: 0px; padding: 0px" v-if="workListStore.currentSelectedSummaryWidget.widgetGridDataArray?.length !== 0">
        <h5
          v-b-toggle.my-collapse
          v-b-tooltip.hover.topleft="{ title: 'Click to Add Patient To Schedule.', customClass: 'my-popover-class', content: 'Critical' }"
          style="text-align: left; padding: 3px 6px"
        >
          Patient Search : {{ workListStore.currentSelectedSummaryWidget.name }}
        </h5>
      </b-row>
      <b-collapse id="my-collapse">
        <WidgetPrimaryCardView :records="filterDummyGrid()" />
      </b-collapse>

      <WidgetSummaryGrid :records="filterDummyGrid()" idField="id" :selectedFileName="selectedFileName" :selected="currentlySelectedRecords" />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, toRaw } from "vue";
// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();

import { useStoreWorkList } from "@/stores/workListsStore";

import WidgetPrimaryCardView from "@/views/WidgetPrimaryCardView.vue";

import WidgetSummaryGrid from "@/modules/WorkLists/WidgetSummaryGrid.vue";

// & PROPS
const props = defineProps({
  records: {
    type: Object,
    default: () => {},
  },
  selectedFileName: {
    type: String,
    default: () => {},
  },
  arrayId: {
    type: Number,
    default: () => {},
  },
});

const workListStore = useStoreWorkList();

const modalTheme = computed(() => userStore.bModalTheme);
const AreIdsShown = ref(false);

// &  ARROW SYNTAX   () => {}
function greetOne() {
  // console.clear();
  // console.log(" Hello  from  greetOne()");
}

const greetTwo = () => {
  // console.clear();
  // console.log(" greetTwo()  says   `Hi`  ");
};

// some [] called names
// names.map(function(){
//   // ...  this is the old way
// })
// names.map((arg) => {
//   // ...  Arrow Syntax
//   return 'hello'
// })
// // * refactors TO >>>>
// names.map((arg) => 'hello')

const filterDummyGrid2 = () => {
  // console.clear();
  // console.log("   () => {}  using  filterDummyGrid2() >>>>>>>>>>>>>>>>>>>>>>>>>>>>");
  // console.dir(props.records);

  if (workListStore.selectedWidgetFilter !== "") {
    return props.records.filter((record) => record.dueText == workListStore.selectedWidgetFilter);
  } else {
    return props.records;
  }
};
// const filterDummyGrid = () => {
//   console.clear()
//   console.log('   () => {}  using  filterDummyGrid() >>>>>>>>>>>>>>>>>>>>>>>>>>>>')
//   // console.log({...workListStore.widgetArray})
//   console.log(toRaw(workListStore.widgetArray));
//   const tempRecords = workListStore.widgetArray;
//   if (workListStore.selectedWidgetFilter !== "") {
//     return tempRecords.filter((record) => record.dueText == workListStore.selectedWidgetFilter);
//   } else {
//     return tempRecords;
//   }
// }
function filterDummyGrid() {
  // console.clear()
  // console.log("GRID PRIMARY");
  // console.log("filterDummyGrid");
  // console.log("      .widgetArray");
  // console.log(workListStore.widgetArray);

  // console.log("");
  const tempRecords = workListStore.widgetArray;

  // console.log("workListStore.selectedWidgetFilter");
  // console.log(workListStore.selectedWidgetFilter);

  if (workListStore.selectedWidgetFilter !== "") {
    return tempRecords.filter((record) => record.dueText == workListStore.selectedWidgetFilter);
  } else {
    return tempRecords;
  }
}

onMounted(() => {
  // console.clear();
  // console.log("onMounted() :     								  WidgetSummaryDetailGridPrimary  >>>>");
  // console.log(" prop   records ");
  // console.log("props : ");
  // console.log({ ...props });
  // console.log({ ...props.records });
});
</script>

<style lang="scss" scoped>
@import "./worklistStyling.scss";

.dx-toolbar .dx-toolbar-items-container {
  height: 0rem !important;
}

.scroll-container,
.scroll-area {
  //max-width: 150px;
  height: 45px * 2;
  max-height: 45px * 4;
  //font-size: 30px;32
}

.scroll-container {
  overflow: auto;
  scroll-snap-type: y mandatory;
}

.scroll-area {
  scroll-snap-align: start;
}

.detailsSlot {
  border: 3px solid transparent;
}

.scroll-container,
.scroll-area {
  margin: 0 auto;
}

.scroll-area {
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.scroll-area:nth-of-type(1) {
  background: #49b293;
}

.scroll-area:nth-of-type(2) {
  background: #c94e4b;
}

.scroll-area:nth-of-type(3) {
  background: #4cc1be;
}

.scroll-area:nth-of-type(4) {
  background: #8360a6;
}
</style>
